var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "#2B4153"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3216 17.9773C17.4297 18.2314 17.7233 18.3498 17.9774 18.2416C18.2315 18.1335 18.3499 17.8399 18.2417 17.5858L17.3216 17.9773ZM12.7413 5.93676L13.2014 5.74098L12.7413 5.93676ZM4.7212 22.3048L11.3586 6.13841L10.4336 5.75861L3.79613 21.925L4.7212 22.3048ZM12.2812 6.13254L17.3216 17.9773L18.2417 17.5858L13.2014 5.74098L12.2812 6.13254ZM11.3586 6.13841C11.5272 5.72779 12.1074 5.72409 12.2812 6.13254L13.2014 5.74098C12.68 4.51566 10.9393 4.52674 10.4336 5.75861L11.3586 6.13841Z",
    fill: "#2B4153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.057 13.7184C21.1649 13.9726 21.4584 14.0912 21.7126 13.9834C21.9668 13.8755 22.0854 13.582 21.9776 13.3278L21.057 13.7184ZM20.2849 10.6181L19.8246 10.8134L20.2849 10.6181ZM8.5027 10.7983L11.9888 19.3332L12.9145 18.955L9.42845 10.4202L8.5027 10.7983ZM14.7269 19.4208L18.9145 10.7904L18.0148 10.3538L13.8272 18.9842L14.7269 19.4208ZM19.8246 10.8134L21.057 13.7184L21.9776 13.3278L20.7452 10.4228L19.8246 10.8134ZM18.9145 10.7904C19.1019 10.4041 19.6569 10.4181 19.8246 10.8134L20.7452 10.4228C20.2421 9.23707 18.577 9.19501 18.0148 10.3538L18.9145 10.7904ZM11.9888 19.3332C12.4794 20.5344 14.1605 20.5882 14.7269 19.4208L13.8272 18.9842C13.6384 19.3734 13.0781 19.3554 12.9145 18.955L11.9888 19.3332Z",
    fill: "#2B4153"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.558689ee8009efd4420d7679cd31c0b1.svg";
export { ForwardRef as ReactComponent };